import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "662px",
    minHeight: "600px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  cancelButton: {
    marginRight: theme.spacing(1),
  },
  changeStepButton: {
    minWidth: "15px",
    height: "15px",
  },
  stepsText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: 0,
    color: theme.palette.primary.dark,
  },
  outlined: {
    padding: 0,
  },
  tab: {
    minWidth: "50px",
    "&.MuiTab-textColorInherit": {
      color: "#190D27",
      opacity: 0.3,
    },
    "&.Mui-selected": {
      color: "#33A3B1",
      opacity: 1,
    },
  },
  textColorPrimary: {
    color: "#33A3B1",
  },
  indicator: { color: "#33A3B1" },
  actionsContainer: {
    bottom: "0px",
    width: "100%",
  },
  contentContainer: {
    height: "560px",
    overflow: "auto",
    paddingBottom: theme.spacing(2),
  },
}))

export default styles
